<template>
  <div class="visitor-register">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <el-date-picker
          v-model="timeValue"
          type="daterange"
          size="small"
          unlink-panels
          :picker-options="pickerOptions"
          @change="changeTimeValue"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>

      </div>
      <input-search placeholder="姓名/手机号/拜访住户" @search="searchKey" />
    </div>
    <table-main :selection="false" :hasOperation="false" :tableHead="tableHead" :tableData="tableData" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" @lookOver="lookOver" />

    <el-dialog
      :visible.sync="dialogVisible"
      width="40%">
      <img :src="lookOverImg" alt="" style="width: 90%;margin: 0 auto;">
    </el-dialog>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import InputSearch from "../../../components/Input/InputSearch";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/Visitor";
import { errorHandler } from "../../../utils/errorHandler";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
import { nSuccess } from "../../../utils/notice";

export default {
  components: {
    ButtonConfirmNext,
    TableMain,
    InputSearch,
    Breadcrumb
  },
  name: "credit-card-record",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧访客",
          name: "appointment-record"
        },
        {
          value: "登记记录"
        }
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      tableHead: [
        {
          prop: "personName",
          label: "来访人姓名"
        },
        {
          prop: "identityNumber",
          label: "身份证号"
        },
        {
          prop: "phone",
          label: "手机号"
        },
        {
          prop: "enterpriseName",
          label: "拜访住户"
        },
        {
          prop: "reason",
          label: "来访缘由"
        },
        {
          prop: "receiver",
          label: "接待人"
        },
        {
          prop: "picUrl",
          label: "人员照片",
          isLookOver: true
        },
        {
          prop: "startTime",
          label: "来访时间"
        },
        {
          prop: "endTime",
          label: "结束时间"
        }
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      timeValue: [],
      requestData: {
        pageNum: 1,
        pageSize: 10,
        startTime: "",
        endTime: "",
        searchKey: ""
      },
      lookOverImg: "",
      dialogVisible: false,

      windowLeftBox: false,
      windowLeftTableHead: [
        {
          prop: "visitorName",
          label: "来访人姓名"
        },
        {
          prop: "visitorPhone",
          label: "来访人手机号"
        },
        {
          prop: "enterpriseName",
          label: "来访人单位"
        },
        {
          prop: "bookingBusiness",
          label: "来访事由"
        },
        {
          prop: "yqPicUrl",
          label: "人员照片",
          isPic: true
        }
      ],
      windowLeftTableData: [],
      windowLeftSearchKey: "",
      windowLeftTotal: 0,
      windowLeftPageNum: 1,
      windowLeftPageSize: 10,
      drawer: false,
      drawerPersonData: {}
    };
  },
  created() {
    this.getCreatTime();
    // this.getPage()
  },
  activated() {
    this.getPage();
  },
  methods: {
    getCreatTime() {
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      // let hour = nowDate.getHours() < 10 ? '0' + nowDate.getHours() : nowDate.getHours()
      // let minute = nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes()
      // let second = nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
      this.timeValue[0] = year + "-" + month + "-" + date;
      this.timeValue[1] = year + "-" + month + "-" + date;
      this.getPage();
    },
    changeTimeValue() {
      this.pageNum = 1;
      this.pageSize = 10;
      this.getPage();
    },
    getPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      reqData.startTime = "";
      reqData.endTime = "";
      if (this.timeValue) {
        if (this.timeValue.length > 0) {
          reqData.startTime = `${this.timeValue[0]} 00:00:00`;
          reqData.endTime = `${this.timeValue[1]} 23:59:59`;
        }
      }
      this.$axios
        .post(api.getVisitorRegisterRecordPage, reqData)
        .then(res => {
          let list = res.data.data.list;
          this.total = res.data.data.total;
          list.map(v => {
            if (v.visitStartTime && v.visitEndTime) {
              v.visitorTime = `${v.visitStartTime}至${v.visitEndTime}`;
            } else {
              v.visitorTime = "";
            }
            if (!v.picUrl) {
              v.picUrl = "";
            }
            if (!v.identityPicUrl) {
              v.identityPicUrl = "";
            }
          });
          this.tableData = list;
        })
        .catch(errorHandler("获取登记记录失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    lookOver(imgUrl) {
      this.lookOverImg = imgUrl;
      this.dialogVisible = true;
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },

    changeWindowLeftPagination(data) {
      this.windowLeftPageNum = data[0];
      this.windowLeftPageSize = data[1];
      this.getVisitorRegisterPage();
    },

    // 展示人员申请
    showWindowLeftBox() {
      this.windowLeftBox = true;
      this.getVisitorRegisterPage();
    },

    // 返回
    personDataToWindowLeft() {
      this.drawer = false;
      this.windowLeftBox = true;
    },

    // 点击人员查看详情
    windowLeftRowClick(row, event, column) {
      this.windowLeftBox = false;
      this.drawer = true;
      this.drawerPersonData = row;
      // this.getPersonBaklogByCode(row.baklogCode)
    },

    windowLeftSearch(v) {
      this.windowLeftPageNum = 1;
      this.windowLeftSearchKey = v;
      this.getVisitorRegisterPage();
    },

    handleClose(done) {
      done();
      this.windowLeftBox = true;
    },

    // 查询人员申请列表
    getVisitorRegisterPage() {
      this.$axios
        .post(api.getVisitorRegisterPage, {
          appointmentStatus: "0",
          pageNum: this.windowLeftPageNum,
          pageSize: this.windowLeftPageSize,
          searchKey: this.windowLeftSearchKey
        })
        .then(res => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map(v => {
              v.yqPicUrl = v.visitorPic;
            });
            this.windowLeftTotal = res.data.data.total;
            this.windowLeftTableData = data;
          }
        })
        .catch(errorHandler("获取申请列表失败"));
    },

    // 同意申请
    confirmApprove() {
      this.$axios
        .post(`${api.passTheVisitor}`, this.drawerPersonData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("操作成功");
            this.drawer = false;
            this.windowLeftBox = true;
            this.getVisitorRegisterPage();
          }
        })
        .catch(errorHandler("操作失败"));
    },

    // 驳回申请
    rejectApprove() {
      let drawerPersonData = this.drawerPersonData;
      drawerPersonData.unApproveReason = this.unApproveReason;
      this.$axios
        .post(`${api.notPassTheVisitor}`, drawerPersonData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("操作成功");
            this.drawer = false;
            this.windowLeftBox = true;
            this.approveDialog = false;
            this.getVisitorRegisterPage();
          }
        })
        .catch(errorHandler("操作失败"));
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>
<style lang="less">
.btn-box {
  .el-date-editor .el-range-separator {
    padding: 0;
  }
}

.visitor-register {
  .right-slide-enter,
  .right-slide-leave-active {
    transform: translateX(100%);
  }

  .right-slide-leave-active,
  .right-slide-enter-active {
    transition: all 0.3s;
  }
  .window-left-box {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 60%;
    z-index: 10;
  }
  .window-left-box .move-enter-active,
  .window-left-box .move-leave-active {
    transition: all 2s linear;
    transform: translate3d(0, 0, 0);
  }
  .window-left-box .move-enter,
  .window-left-box .move-leave {
    transform: translate3d(100%, 0, 0);
  }
  .window-left-main {
    width: 100%;
    height: 100%;
    z-index: 30;
    background: #ffffff;
    padding: 5px 10px;
    overflow: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0.4;
    z-index: -1;
    background-color: #000000;
    transition: opacity 0.5s ease;
  }

  form {
    width: 450px;
    margin: 0 auto;
    text-align: left;
  }
  .form-line {
    margin: 25px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .line-text {
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 100px;
    display: flex;
    justify-content: space-between;
  }
  .line-info {
    width: 220px;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }

  .person-management-drawer {
    .el-icon-back {
      margin: 20px 20px 10px;
      display: block;
      border: 0;
      font-size: 20px;
      background-color: #ffffff;
      cursor: pointer;
    }
    .el-icon-back:hover {
      color: #00a0e6;
    }
    .all-table-class .el-table td {
      padding: 10px 0;
    }
    form {
      position: relative;
      .drawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
      }
      .noDrawerPersonImg {
        position: absolute;
        right: 0;
        top: 0;
        width: 120px;
        height: 150px;
        line-height: 160px;
        border: 1px dashed #dcdfe6;
        text-align: center;
        color: #999999;
      }
    }
  }
  .drawerBtnBox {
    width: 360px;
    padding-right: 60px;
    margin: 0 auto;
    .btn-confirm {
      border: 0;
      color: #fff;
      padding: 8px 16px;
      background-color: #00a0e6;
      border-radius: 4px;
      margin-right: 60px;
    }
    .btn-confirm:hover {
      color: #fff;
      background-color: #06b3ff;
    }
    .reject-button {
      border: 0;
      background-color: #f25721;
      color: #ffffff;
      border-radius: 4px;
    }
    .reject-button:hover {
      background-color: #f96e3d;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/VisitorCenter/VisitorRegister/VisitorRegister.vue